export default "__VITE_ASSET__PyEC8mAE__"